import { keepPreviousData } from "@tanstack/react-query"
import {
  useListGdeltBiothreatSignalsFacetsGdeltBiothreatSignalsFacetsGet,
  useListNwssBiothreatSignalsFacetsNwssBiothreatSignalsFacetsGet,
  type GdeltBiothreatSignalsFacets,
  type NwssBiothreatSignalsFacets,
} from "@phc/common/gen/threatAnalyticsGen"
import {
  useGdeltDateFilterParams,
  useNwssDateParams,
} from "./usePrecomputedDateRangeParams"

export const useGdeltFilterFacets = () => {
  const dateFilterParams = useGdeltDateFilterParams()
  return useListGdeltBiothreatSignalsFacetsGdeltBiothreatSignalsFacetsGet(
    {
      ...dateFilterParams,
      has_impact_score: true,
    },
    { query: { placeholderData: keepPreviousData } }
  )
}

export type GdeltFilterFacetsQuery = ReturnType<typeof useGdeltFilterFacets>
export type GdeltFilterFacetsData = GdeltBiothreatSignalsFacets

export const useNwssFilterFacets = () => {
  const dateParams = useNwssDateParams()
  return useListNwssBiothreatSignalsFacetsNwssBiothreatSignalsFacetsGet(
    {
      ...dateParams,
    },
    { query: { placeholderData: keepPreviousData } }
  )
}

export type NwssFilterFacetsQuery = ReturnType<typeof useNwssFilterFacets>
export type NwssFilterFacetsData = NwssBiothreatSignalsFacets
